<section class="page-title" style="background-image: url(assets/images/breadcom.png);">
  <div class="auto-container">
    <div class="content-box">
      <div class="row">
        <div class="col-6">
          <div class="title">
            <h1>Login</h1>
          </div>
        </div>
        <div class="col-6">


          <ul class="bread-crumb clearfix text-right">
            <li><a routerLink="/">Home</a></li>
            <li>Login</li>
          </ul>
        </div>

      </div>

    </div>
  </div>
</section>


<div id="main-wrapper" class="oxyy-login-register">
  <div class="container-fluid">
    <div class="row g-0 banner-inactive">
      Welcome to the revamped NDM website. We have removed some inactive users from the system. If you face any
      difficulties/issues during login, please click on this &nbsp; <a style="color: #fff;text-decoration:underline"
        routerLink="../activate-user"> Activate account </a> link and follow the instructions to reinstate your account.
      We are happy to help you. Thank you
    </div>
    <div class="row g-0 min-vh-100">
      <!-- Welcome Text
        ========================= -->
      <div class="col-md-6">
        <div class="hero-wrap d-flex align-items-center h-100">
          <div class="hero-mask opacity-8 bg-primary"></div>

          <div class="hero-content w-100 min-vh-100 d-flex flex-column">

            <div class="row g-0 my-auto">
              <div class="col-10 col-lg-9 mx-auto">
                <h1 class="text-11  mb-4"><span>ANMW</span> National Distribution Monitor</h1>
                <p class="text-4  lh-base mb-5">Welcome to the ANMW National Distribution Monitor which provides
                  constantly updated
                  information on national newspaper distribution throughout the UK.</p>

                <img src="./assets/images/loginimg.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Welcome Text End -->

      <!-- Login Form
        ========================= -->
      <div class="col-md-6 d-flex login_pag">
        <div class="container">
          <div class="row g-0">
            <div class="col-10 col-lg-10 col-xl-9 mx-auto">
              <div class="main_login login_pag">
                <h3 class="fw-600 ">Sign In</h3>
                <p class="mb-4">Enter your credentials to get access</p>
                <form id="loginForm" (ngSubmit)="authenticate()" [formGroup]="loginForm">
                  <div class="mb-2">
                    <label for="emailAddress" class="form-label">User Name</label>
                    <input type="email" formControlName="userName" class="form-control" id="emailAddress" required
                      placeholder="Enter Your User Name">
                    <div
                      *ngIf="loginForm.controls['userName'].invalid && (loginForm.controls['userName'].dirty|| loginForm.controls['userName'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      User Name required.
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="loginPassword" class="form-label">Password</label>
                    <input type="password" formControlName="password" class="form-control" id="loginPassword" required
                      placeholder="Enter Password">

                    <div
                      *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty|| loginForm.controls['password'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Password required.
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-9">
                      <div class="col text-end"><a routerLink="../forgot-password">Forgot Password ?</a>
                        &nbsp;<a class="link-primary" routerLink="../create-user">Register here </a>
                      </div>
                    </div>
                    <div class="col-3">

                      <div class="d-grid text-right">
                        <button type="submit" class="theme-btn style-two">Login</button>
                      </div>
                    </div>
                  </div>

                </form>
                <p class="text-muted mb-0 ml-1">Inactive users can <a class="link-primary"
                    routerLink="../activate-user">Activate account </a>here.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Login Form End -->
    </div>
  </div>
</div>
<app-footer></app-footer>